var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "base",
      staticClass: "vc-popup-base",
      style: { position: _vm.positionType },
      on: {
        touchmove: _vm._maskPreventScroll,
        mousewheel: _vm._maskPreventScroll,
        DOMMouseScroll: _vm._maskPreventScroll
      }
    },
    [
      _c("div", {
        ref: "mask",
        staticClass: "vc-popup-mask",
        on: { click: _vm._turnOffMask }
      }),
      _vm._v(" "),
      _c("div", { ref: "slotContainer", staticClass: "vc-popup-slot" }, [
        _c("div", { ref: "slot", on: { touchmove: _vm._stopPropagation } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76ca6e5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ca6e5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup-base/popup-base.vue
// module id = 48
// module chunks = 1